"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChannelType = exports.CorrelationType = exports.motSurvey = exports.SurveyResponseID = exports.SurveyQuestionID = exports.SurveyType = void 0;
var SurveyType;
(function (SurveyType) {
    SurveyType["MoTUsefulness"] = "mot_usefulness";
})(SurveyType || (exports.SurveyType = SurveyType = {}));
var SurveyQuestionID;
(function (SurveyQuestionID) {
    SurveyQuestionID["MoTUsefulnessIsItUseful"] = "is_it_useful";
    SurveyQuestionID["MoTUsefulnessWhyIsItNotUseful"] = "why_is_it_not_useful";
    SurveyQuestionID["MoTUsefulnessWhatWouldYouLikeToDo"] = "what_would_you_like_to_do";
})(SurveyQuestionID || (exports.SurveyQuestionID = SurveyQuestionID = {}));
var SurveyResponseID;
(function (SurveyResponseID) {
    SurveyResponseID["MoTUsefulnessItIsUseful"] = "useful";
    SurveyResponseID["MoTUsefulnessItIsNotUseful"] = "not_useful";
    SurveyResponseID["MoTUsefulnessNotReduceWorkload"] = "not_reduce_workload";
    SurveyResponseID["MoTUsefulnessDoesNotSupportWithPlanningCosts"] = "does_not_support_with_planning_costs";
    SurveyResponseID["MoTUsefulnessNotAccurate"] = "not_accurate";
    SurveyResponseID["MoTUsefulnessUnclear"] = "unclear";
    SurveyResponseID["MoTUsefulnessTooMany"] = "too_many";
    SurveyResponseID["MoTUsefulnessUnsureWhatToDo"] = "unsure_what_to_do";
    SurveyResponseID["MoTUsefulnessNotRelevant"] = "not_relevant";
    SurveyResponseID["MoTUsefulnessUnsubscribe"] = "unsubscribe";
    SurveyResponseID["MoTUsefulnessConfigure"] = "configure";
})(SurveyResponseID || (exports.SurveyResponseID = SurveyResponseID = {}));
exports.motSurvey = {
    id: SurveyType.MoTUsefulness,
    questions: {
        [SurveyQuestionID.MoTUsefulnessIsItUseful]: {
            id: SurveyQuestionID.MoTUsefulnessIsItUseful,
            translationKey: 'mot-survey-is-it-useful',
            responses: [
                { id: SurveyResponseID.MoTUsefulnessItIsUseful, translationKey: 'mot-survey-yes' },
                { id: SurveyResponseID.MoTUsefulnessItIsNotUseful, translationKey: 'mot-survey-no' },
            ],
        },
        [SurveyQuestionID.MoTUsefulnessWhyIsItNotUseful]: {
            id: SurveyQuestionID.MoTUsefulnessWhyIsItNotUseful,
            translationKey: 'mot-survey-why-not-useful',
            responses: [
                {
                    id: SurveyResponseID.MoTUsefulnessNotReduceWorkload,
                    translationKey: 'mot-survey-does-not-reduce-workload',
                },
                {
                    id: SurveyResponseID.MoTUsefulnessDoesNotSupportWithPlanningCosts,
                    translationKey: 'mot-survey-does-not-support-with-planning-costs',
                },
                { id: SurveyResponseID.MoTUsefulnessNotAccurate, translationKey: 'mot-survey-not-accurate' },
                { id: SurveyResponseID.MoTUsefulnessUnclear, translationKey: 'mot-survey-unclear' },
                { id: SurveyResponseID.MoTUsefulnessTooMany, translationKey: 'mot-survey-too-many' },
                { id: SurveyResponseID.MoTUsefulnessUnsureWhatToDo, translationKey: 'mot-survey-unsure-what-to-do' },
                { id: SurveyResponseID.MoTUsefulnessNotRelevant, translationKey: 'mot-survey-not-relevant' },
            ],
        },
        [SurveyQuestionID.MoTUsefulnessWhatWouldYouLikeToDo]: {
            id: SurveyQuestionID.MoTUsefulnessWhatWouldYouLikeToDo,
            translationKey: 'mot-survey-what-would-you-like-to-do',
            responses: [
                { id: SurveyResponseID.MoTUsefulnessUnsubscribe, translationKey: 'mot-survey-unsubscribe' },
                { id: SurveyResponseID.MoTUsefulnessConfigure, translationKey: 'mot-survey-configure' },
            ],
        },
    },
};
var CorrelationType;
(function (CorrelationType) {
    CorrelationType["CustomerNotification"] = "customerNotification";
    CorrelationType["DailyDigestNotification"] = "dailyDigestNotification";
    CorrelationType["UserNotification"] = "userNotification";
    CorrelationType["ActivityFeed"] = "activityFeed";
})(CorrelationType || (exports.CorrelationType = CorrelationType = {}));
var ChannelType;
(function (ChannelType) {
    ChannelType["Email"] = "email";
    ChannelType["Web"] = "web";
    ChannelType["ActivityFeed"] = "activityFeed";
})(ChannelType || (exports.ChannelType = ChannelType = {}));
//# sourceMappingURL=survey.js.map